import React, { useEffect, useState, useRef } from "react"
import { useNavigate, Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Select from 'react-select'

import ReactSelect from 'pages/parts/ReactSelect'
import usePreventExit from "pages/parts/usePreventExit"
import DocumentTemplate from 'pages/parts/DocumentTemplate'
import NotInventored from "pages/main/inventory/NotInventored"
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

function CreateUpdate() {
	const { t } = useTranslation();
	const { id } = useParams();
	const navigate = useNavigate();

	const [isDirty, setIsDirty] = useState(false);
	usePreventExit(isDirty);

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const reduxAccount = useSelector(state => state.account)

	const [wms, setWms] = useState([])
	const [elements, setElements] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalNotInventored, setModalNotInventored] = useState(false)
	const [addQuantity, setAddQuantity] = useState(1)
	const [data, setData] = useState({
		'pos_id': reduxAccount.pos_id,
		'wms_id': reduxAccount.wms_id,
		'elements': [],
	})
	// TEMPLATE
	const [products, setProducts] = useState([])
	const [modalTemplate, setModalTemplate] = useState({ 'bool': false, 'templates': [] })
	const [modalTemplateCRUD, setModalTemplateCRUD] = useState({ 'bool': false, 'name': "", 'items': [] })
	// TEMPLATE

	async function inventoryCompleted(completed = false) {
		var sendData = { ...data }

		for (let i = 0; i < sendData.elements.length; i++) {
			if (sendData.elements[i]['actual_balance'] < 0 || sendData.elements[i]['actual_balance'] === "") {
				sendData.error = true
			}

			sendData.elements[i]['difference_amount'] = (sendData.elements[i]['actual_balance'] - sendData.elements[i]['balance']) * sendData.elements[i]['price']
			sendData.elements[i]['divergence'] = sendData.elements[i]['actual_balance'] - sendData.elements[i]['balance']
		}

		if (sendData.error) {
			toast.error(t('check_filled_inputs'))
			return
		}

		var response;
		if (id) {
			if (completed) {
				response = await PUT('/inventory-completed', sendData, { loader: true })
				if (httpOk(response)) navigate('/inventory-wms')
			} else {
				response = await PUT('/inventory', sendData, { loader: true })
				if (httpOk(response)) navigate('/inventory-wms')
			}
		} else {
			if (completed) {
				response = await PUT('/inventory-completed', sendData, { loader: true })
				if (httpOk(response)) navigate('/inventory-wms')
			} else {
				response = await POST('/inventory', sendData, { loader: true })
				if (httpOk(response)) navigate('/inventory-wms')
			}
		}
	}

	function handleChangeWMS(option) {
		setData({ ...data, 'wms_id': option.id, 'wms_name': option.name })
		getElements(option.id)
	}

	function handleProductsChange(e, index) {
		var dataCopy = { ...data }
		if (Number(e.target.value) > 999999999) {
			toast.error(t('exceeds_maximum'))
			dataCopy.elements[index][e.target.name] = ""
			setData(dataCopy)
			return;
		}

		dataCopy.elements[index][e.target.name] = e.target.value.replace(/[^0-9.]/g, '')
		calculate(dataCopy)
	}

	function deleteProduct(index) {
		var dataCopy = { ...data }
		dataCopy.elements.splice(index, 1)
		setData(dataCopy)
	}

	function addToList(length = 1) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.elements.push({
				"price": "",
				"element_id": "",
				"actual_balance": "",
				"name": "",
				"unit_name": "",
				"balance": "",
				"difference_amount": '',
				"divergence": ''
			})
		}

		setIsDirty(true)
		setData(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(1)
			byId?.select()
		}, 200);
	}

	function calculate(dataCopy) {
		dataCopy.balance = 0
		dataCopy.divergence = 0
		dataCopy.difference_amount = 0

		for (let i = 0; i < dataCopy.elements.length; i++) {
			dataCopy.elements[i]['divergence'] = dataCopy.elements[i]['actual_balance'] - dataCopy.elements[i]['balance']
			dataCopy.elements[i]['difference_amount'] = (dataCopy.elements[i]['actual_balance'] - dataCopy.elements[i]['balance']) * dataCopy.elements[i]['price']
		}
		setData(dataCopy)
	}

	async function notInventoredList() {
		// var arrayIds = []
		// for (let i = 0; i < data.elements.length; i++) {
		// 	arrayIds.push(data.elements[i]['element_id'])
		// }
		// var sendData = {
		// 	"balance_ids": [],
		// 	"pos_id": data.pos_id,
		// 	"wms_id": data.wms_id
		// }
		// sendData.balance_ids = arrayIds

		// const response = await POST('/inventory/not-inventored', sendData, { loader: true })
		// if (httpOk(response)) {
		// 	var list = [...response.data]
		// 	for (let i = 0; i < list.length; i++) {
		// 		list[i]['selected'] = false
		// 		list[i]['actual_balance'] = list[i]['balance']
		// 	}

		// 	setNotInventoredProducts(list)
		setModalNotInventored(true)
		//}
	}

	async function getData() {
		if (!id) {
			getElements(reduxAccount.wms_id)
		}

		if (id) {
			const response = await GET(`/inventory/${id}`)
			if (httpOk(response)) {
				setData(response.data)
				getElements(response.data.wms_id)
			}
		}
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) {
			setElements([...elementsDuplicate])
			return
		}
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setElements(filteredItems)
	}

	function handleSelectElement(option, index) {
		var dataCopy = { ...data }

		dataCopy.elements[index]['balance_id'] = option.balance_id
		dataCopy.elements[index]['element_id'] = option.element_id
		dataCopy.elements[index]['name'] = option.name
		dataCopy.elements[index]['unit_name'] = option.unit_name
		dataCopy.elements[index]['price'] = option.price
		dataCopy.elements[index]['balance'] = option.balance
		dataCopy.elements[index]['actual_balance'] = ''
		dataCopy.elements[index]['divergence'] = ''
		dataCopy.elements[index]['difference_amount'] = ''

		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...elements]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true

			setElements(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = elements.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...elements]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[elements.length - 1].selected = true
						currentIndex = elements.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === elements.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setElements(elementsCopy)
		}
	}
	// REACTSELECT LOGIC

	// TEMPLATE LOGIC
	async function toggleModalTemplate(bool) {
		if (bool) {
			const response = await GET(`/documents-templates`, {}, { loader: true })
			if (httpOk(response)) {
				setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': response.data })
			}
		} else {
			setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': [] })
		}
	}

	async function toggleModalTemplateCRUD(bool) {
		if (bool) {
			const response = await GET(`/documents-templates-all-products`, {}, { loader: true })
			if (httpOk(response)) {
				setProducts(response.data)
				setModalTemplateCRUD({ ...modalTemplateCRUD, 'bool': bool, 'name': "", 'products': [] })
			}
		} else {
			setModalTemplateCRUD({ ...modalTemplateCRUD, 'bool': bool, 'name': "", 'products': [] })
		}
	}

	async function handleSelectTemplate(item) {
		var response = await GET(`/documents-templates-products/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			response = response.data
			debugger
			var items = []
			for (let i = 0; i < response.length; i++) {
				for (let j = 0; j < elementsDuplicate.length; j++) {
					if (response[i]['product_id'] === elementsDuplicate[j]['element_id']) {
						elementsDuplicate[j]['element_id'] = response[i]['product_id'] // изменить потом на product_id
						items.push(elementsDuplicate[j])
					}
				}
			}

			setData({ ...data, 'elements': items })
			toggleModalTemplate(false)
		}
	}

	async function deleteTemplate(item) {
		const response = await DELETE(`/documents-templates/${item.id}`, {}, { loader: true })
		if (httpOk(response)) toggleModalTemplate(false)
	}
	// TEMPLATE LOGIC

	async function getWms() {
		const response = await GET(`/helper/wms?pos_id=${reduxAccount.pos_id}`)
		if (httpOk(response)) setWms(response.data)
	}

	async function getElements(wms_id) {
		var sendData = {
			"pos_id": reduxAccount.pos_id,
			"wms_id": wms_id,
		}
		const response = await GET(`/inventory-elements`, sendData)
		if (httpOk(response)) {
			setElements(response.data)
			setElementsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getData()
		getWms()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between flex-wrap mb-2">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('inventory')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
				<div className="d-flex gap-2">
					<button className="btn btn-primary"
						onClick={() => notInventoredList()}>
						{t('not_inventored')}
					</button>
					<DropdownButton title={t('action')}>
						<Dropdown.Item onClick={() => toggleModalTemplate(true)}>
							{t('templates')}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => toggleModalTemplateCRUD(true)}>
							{t('create_template')}
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-groups">
								<label>{t('wms')}<span className="required-mark">*</span></label>
								<Select
									isDisabled={data.id}
									value={wms.find(option => option.id === data.wms_id)}
									options={wms}
									onChange={(option) => handleChangeWMS(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label>{t('note')}</label>
								<input name="note" className="form-control"
									autoComplete="off"
									value={data.note ?? ''}
									onChange={(e) => setData({ ...data, 'note': e.target.value })} />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
						<thead>
							<tr>
								<th style={{ 'minWidth': '40px' }} className="text-center">#</th>
								<th style={{ 'width': '30%' }}>{t('name2')}</th>
								<th style={{ 'width': '10%' }} className="text-end">{t('price')}</th>
								<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
								<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
								<th style={{ 'width': '10%' }} className="text-end">{t('counted')}</th>
								<th style={{ 'width': '10%' }} className="text-end">{t('difference')}</th>
								<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
								<th style={{ 'minWidth': '35px' }} className="text-end"></th>
							</tr>
						</thead>
						<tbody>
							{data.elements.map((item, index) => (
								<tr key={index}>
									<td className="text-center">{index + 1}</td>
									<td>
										<ReactSelect
											search={handleSelectSearch}
											value={item.name}
											index={index}
											scrollRef={scrollRef}
											options={elements}
											onClose={() => closeReactSelect()}
											selectItem={(option) => handleSelectElement(option, index)}
											onKeyUp={(e) => {
												if (e.keyCode === 40 || e.keyCode === 38) {
													handleTableKeyDown(e)
												}
											}}
											table={
												<table className="table mb-0">
													<tbody ref={tbodyRef}>
														{elements.map((selectItem, selectIndex) => (
															<tr
																id={selectItem.id}
																className={`cursor ${((selectItem.selected || (selectItem.id === item.element_id)) ? 'selected' : '')}`}
																tabIndex={-1}
																key={selectIndex}
																onClick={() => handleSelectElement(selectItem, index)}
																onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																<td>{selectItem.name}</td>
																<td className="text-end text-nowrap">{formatMoney(selectItem.price)}</td>
															</tr>
														))}
													</tbody>
												</table>
											}
										/>
									</td>
									<td className="vertical-middle text-end text-nowrap">{formatMoney(item.price)}</td>
									<td className="vertical-middle text-end text-nowrap">{formatMoney(item.balance, 2)}</td>
									<td className="vertical-middle">{item.unit_name}</td>
									<td className="td-input" style={!item.actual_balance ? { 'borderBottom': '2px solid red' } : {}}>
										<input
											type="text"
											name="actual_balance"
											autoComplete="off"
											className={`form-control text-end ${item.actual_balance < 0 ? 'required-border' : ''}`}
											placeholder="0"
											value={item.actual_balance ?? ''}
											onChange={(e) => handleProductsChange(e, index)}
											onKeyUp={(event) => {
												if (event.key === 'Enter') {
													addToList()
												}
											}} />
									</td>
									<td className="text-end text-nowrap">
										<span className={`${item.divergence < 0 ? 'text-danger' : ''}`}>
											{formatMoney(item.divergence, 2)}
										</span>
									</td>
									<td className="text-end text-nowrap">
										<span className={`${item.difference_amount < 0 ? 'text-danger' : ''}`}>
											{formatMoney(item.difference_amount, 2)}
										</span>
									</td>
									<td className="vertical-middle">
										<div className="d-flex justify-content-center"
											onClick={() => deleteProduct(index)}>
											<div className="table-action-button table-action-danger-button">
												<i className="uil uil-times"></i>
											</div>
										</div>
									</td>
								</tr>
							))}
						</tbody>
						<tfoot>
							<tr>
								<td className="td-input">
									<input
										type="text"
										className="form-control text-center"
										style={{ 'padding': '5px 0' }}
										tabIndex={-1}
										value={addQuantity}
										onChange={(e) => setAddQuantity(e.target.value.replace(/[^\d]/g, ''))}
									/>
								</td>
								<td colSpan={1} style={{ 'padding': 0 }}>
									<div className="d-flex">
										<div className="w-100">
											<button type="button" className="btn-sm btn-primary w-100"
												disabled={!data.pos_id}
												onClick={() => {
													setAddQuantity(1)
													addToList(addQuantity)
												}}>
												{t('add')}
											</button>
										</div>
									</div>
								</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
							</tr>
						</tfoot>
					</table>

					<div className="btn-wrapper gap-2 mt-5">
						<Link to="/inventory-wms" className="btn btn-warning btn-rounded btn-wide">
							{t('back')}
						</Link>
						<button type="button" className="btn btn-success btn-rounded btn-wide"
							disabled={!data.elements.length > 0}
							onClick={() => setModalConfirm(true)}>
							{t('complete')}
						</button>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							disabled={!data.elements.length > 0}
							onClick={() => inventoryCompleted()}>
							{t('save_to_draft')}
						</button>
					</div>
				</div>
			</div>

			<NotInventored
				data={data}
				setData={setData}
				modalNotInventored={modalNotInventored}
				setModalNotInventored={setModalNotInventored}>
			</NotInventored>

			{/* MODAL CONFIRM */}
			<Modal show={modalConfirm} animation={false} centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('confirm')}</Modal.Title>
				</Modal.Header>
				<Modal.Footer>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => inventoryCompleted(true)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL CONFIRM */}

			{/* MODAL TEMPLATE */}
			<Modal show={modalTemplate.bool} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModalTemplate(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('templates')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '100%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{modalTemplate?.templates?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" style={{ 'minWidth': '33px' }}>{index + 1}</td>
										<td className="w-100"
											onClick={() => handleSelectTemplate(item)}>
											{item.name}
										</td>
										<td lassName="text-center" style={{ 'minWidth': '33px' }}>
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteTemplate(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TEMPLATE */}

			{/* MODAL TEMPLATE */}
			{modalTemplateCRUD.bool &&
				<DocumentTemplate
					products={products}
					modalTemplateCRUD={modalTemplateCRUD}
					setModalTemplateCRUD={setModalTemplateCRUD}
					toggleModalTemplateCRUD={toggleModalTemplateCRUD}>
				</DocumentTemplate>
			}
			{/* MODAL TEMPLATE */}
		</>
	)
}

export default CreateUpdate

